import React from "react";
import s from "./NewsPreview.module.css";
const NewsPreviewElement = (props) => {
  const hasImage = props.img && props.img.trim() !== '' && props.img !== 'true';
  
  return (
    <a className={s.newsPreviewA} href={props.source} target="_blank">
      <div className={s.card}>
        <div className={s.imgArea}>
          {hasImage ? (
            <img 
              src={props.img} 
              alt={props.name}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div 
            style={{ 
              display: hasImage ? 'none' : 'flex', 
              width: '100%', 
              height: '100%', 
              backgroundColor: '#f0f0f0', 
              alignItems: 'center', 
              justifyContent: 'center',
              color: '#666',
              fontSize: '14px'
            }}
          >
            {hasImage ? 'Изображение недоступно' : 'Нет изображения'}
          </div>
          <div className={s.overlay}>
            <p>Продолжить чтение в соцсети "Вконтакте"</p>
          </div>
        </div>

        <div className={s.info}>
          <h3>{props.name}</h3>
          <p>{props.description}</p>
        </div>
      </div>
    </a>
  );
};
export default NewsPreviewElement;
